import { useEffect, useState, useRef } from 'react';
import { throttle } from 'lodash';

export const useTrackScrollPosition = () => {
  const animationFrameId = useRef<number | null>(null);
  const [scrollPosition, setScrollPosition] = useState(window.scrollY);

  useEffect(() => {
    // if animation already in progress, do nothing
    if (animationFrameId.current) {
      return;
    }

    const updatePosition = () => {
      animationFrameId.current = requestAnimationFrame(() => {
        setScrollPosition(window.scrollY);
        animationFrameId.current = null;
      });
    };

    const throttled = throttle(updatePosition, 500);

    // 'passive' is another tool for promoting effiency
    window.addEventListener('scroll', throttled, { passive: true });

    return () => {
      window.removeEventListener('scroll', throttled);
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
    };
  }, []);

  return scrollPosition;
};
